export default __webpack_public_path__ + "static/media/cs-a018-2.3b06dd19.svg";